// Texts for the taxi/VTC fleet panel (`/fleet/:fleetId/…`, phase 3 of
// docs/flotas-drivers). Registered in AppComponent and merged with
// drivers-fleet/en.ts.
export const locale = {
  lang: 'en',
  data: {
    DRIVERS_FLEET: {
      PANEL: {
        ACTIONS: 'Actions',
        EDIT: 'Edit',
        SAVED: 'Saved',
        COPY: 'Copy',
        COPIED: 'Copied',
        DATE_FROM: 'From',
        DATE_TO: 'To',
        RANGE_INVALID: '“From” date can’t be later than “To” date.',
        GENERIC_ERROR: 'We couldn’t complete the action. Please try again.',
        WEEKDAY: { 1: 'Monday', 2: 'Tuesday', 3: 'Wednesday', 4: 'Thursday', 5: 'Friday', 6: 'Saturday', 7: 'Sunday' },
        OVERVIEW: {
          LOAD_ERROR: 'We couldn’t load the overview.',
          KPI_FEE: 'Passenger fee',
          KPI_FEE_NOTE: 'Not deducted from your revenue',
          ALERTS_TITLE: 'Needs your attention',
          START_TITLE: 'Getting started',
          START_SUB: '{{done}} of {{total}} done. Once everything is ready, your drivers can start working.',
          START_GO: 'Start',
          CHART_TITLE: 'Trips per day',
          CHART_Q: 'How many trips have your drivers made in the last {{days}} days?',
          CHART_EMPTY: 'No trips in this period yet.',
          TIP_TRIPS: 'Trips',
          TOP_EMPTY: 'No trips in this period.',
          TOP_TRIPS: '{{count}} trips',
        },
        DRIVERS: {
          TABS_ARIA: 'Driver status',
          COL_DRIVER: 'Driver',
          COL_DOCUMENTS: 'Documents',
          DOCS_TOOLTIP:
            'Approved: {{approved}} · In review: {{inReview}} · Rejected: {{rejected}} · Pending: {{pending}} · Expired: {{expired}}',
          EMPTY_FILTERED: 'No drivers match your search.',
          LOAD_ERROR: 'We couldn’t load the drivers.',
          SHOWING: 'Showing {{shown}} of {{total}} drivers',
          PER_PAGE: '{{count}} per page',
          PER_PAGE_ARIA: 'Drivers per page',
          ACCEPT: 'Accept',
          ACCEPTING: 'Accepting…',
          ACCEPT_TITLE: 'Accept driver',
          ACCEPTED_TITLE: '{{name}} is now part of the fleet',
          ACCEPT_ERROR: 'We couldn’t accept the request.',
          EMPLOYMENT_LABEL: 'How they work for the fleet',
          EMPLOYMENT_REQUIRED: 'Choose whether they’re self-employed or an employee.',
          SELF_EMPLOYED_HINT: 'Invoices their trips and keeps a % of what they earn.',
          SALARIED_HINT: 'Works under a contract: the fleet collects the full trip fares.',
          SHARE_LABEL: '% the driver keeps',
          SHARE_PLACEHOLDER: 'The fleet’s default',
          SHARE_HINT: 'If you leave it empty, the fleet’s default split applies.',
          SHARE_INVALID: 'Enter a percentage between 0 and 100.',
          REJECT: 'Reject',
          REJECTING: 'Rejecting…',
          REJECTED_DONE: 'Rejected',
          REJECT_TITLE: 'Reject {{name}}’s request',
          REJECT_TEXT: 'They won’t join the fleet. They can ask again with the code.',
          REJECT_PLACEHOLDER: 'Reason (optional, the driver will see it)',
          REJECT_ERROR: 'We couldn’t reject the request',
          REGENERATE: 'Change code',
          REGENERATING: 'Changing…',
          REGENERATED: 'Changed',
          REGENERATE_TITLE: 'Change the fleet code',
          REGENERATE_TEXT: 'The current code stops working. Drivers already linked aren’t affected.',
          REGENERATE_ERROR: 'We couldn’t change the code',
        },
        DRIVER: {
          TITLE: 'Driver profile',
          LOAD_ERROR: 'We couldn’t load the driver.',
          DOCS_TITLE: 'Documents',
          DOCS_SUB: 'WAIIS reviews them. You only see their status here; the driver uploads them from the app.',
          DOCS_EMPTY: 'They haven’t uploaded any documents yet.',
          REMOVE: 'Unlink',
          REMOVING: 'Unlinking…',
          REMOVED: 'Unlinked',
          REMOVE_TITLE: 'Unlink {{name}}',
          REMOVE_TEXT: 'They’ll stop working for the fleet and be removed from all their shifts.',
          REMOVE_ERROR: 'We couldn’t unlink the driver',
          REMOVED_SHIFTS: 'Driver unlinked. {{count}} shift slots have been freed up.',
        },
        VEHICLES: {
          ADD: 'Add vehicle',
          TABS_ARIA: 'Vehicle status',
          TAB_ALL: 'All',
          COL_PLATE: 'Plate',
          COL_SEATS: 'Seats',
          LICENSE_taxi: 'Municipal licence no.',
          LICENSE_vtc: 'VTC authorisation no.',
          EMPTY: 'You haven’t registered any vehicles yet.',
          EMPTY_FILTERED: 'No vehicles match the filters.',
          LOAD_ERROR: 'We couldn’t load the vehicles.',
          SHOWING: 'Showing {{shown}} of {{total}} vehicles',
          PER_PAGE: '{{count}} per page',
          PER_PAGE_ARIA: 'Vehicles per page',
          BRAND: 'Make',
          MODEL: 'Model',
          PLATE_INVALID: 'The plate isn’t valid.',
          DELETE: 'Remove',
          DELETING: 'Removing…',
          DELETED: 'Removed',
          DELETE_TITLE: 'Remove {{plate}}',
          DELETE_TEXT: 'The vehicle leaves the fleet and is removed from all shifts.',
          DELETE_ERROR: 'We couldn’t remove the vehicle',
          DELETED_SHIFTS: 'Vehicle removed. {{count}} shift slots have been freed up.',
        },
        SHIFTS: {
          SAVE: 'Save shifts',
          DISCARD: 'Discard changes',
          LOAD_ERROR: 'We couldn’t load the shifts.',
          SAVE_ERROR: 'We couldn’t save the shifts.',
          LOCKED: 'To organise shifts you need at least one vehicle and one accepted driver.',
          FREE: 'free',
          OUTDATED_TITLE: 'The shifts have changed',
          RELOAD: 'Reload',
        },
        DOCUMENTS: {
          LOAD_ERROR: 'We couldn’t load the documents.',
          COMPANY: 'Company',
          URGENCY: {
            in_review: 'In review',
            valid: 'Up to date',
          },
          EMPTY: 'There are no vehicles in the fleet yet.',
          UPLOADED_AT: 'Uploaded on {{date}}',
          VIEW_ERROR: 'The document couldn’t be opened.',
        },
        SETTLEMENTS: {
          EXPORT: 'Export CSV',
          INFO_TITLE: 'For information only, for now',
          SUMMARY_ERROR: 'We couldn’t load the summary.',
          NEXT_PAYOUT: 'Next payout',
          DEFAULT_SHARE: 'Default split',
          MOVEMENTS_TITLE: 'Transactions',
          MOVEMENTS_SUB:
            'Each row is money that has already moved. The passenger fee (only on WAIIS app trips; your own customers pay €0) is paid on top of the fare: you get the full fare.',
          TYPE_ALL: 'All types',
          TYPE_ARIA: 'Transaction type',
          TYPE: {
            trip_earning: 'Trip',
            driver_share: 'Driver’s share',
            payout: 'Settlement',
            adjustment: 'Adjustment',
          },
          DRIVER_ALL: 'All drivers',
          DRIVER_ARIA: 'Driver',
          COL_DATE: 'Date',
          COL_TYPE: 'Type',
          COL_DRIVER: 'Driver',
          COL_DESCRIPTION: 'Description',
          COL_FARE: 'Fare',
          COL_COMMISSION: 'Fee',
          COL_PASSENGER: 'Passenger pays',
          COL_AMOUNT: 'Fleet amount',
          COMMISSION_TOOLTIP: 'Paid by the passenger on top of the fare, only on trips that come through the WAIIS app. It isn’t deducted from what the fleet earns.',
          EMPTY: 'No transactions in this period.',
          LOAD_ERROR: 'We couldn’t load the transactions.',
          SHOWING: 'Showing {{shown}} of {{total}} transactions',
          PER_PAGE: '{{count}} per page',
          PER_PAGE_ARIA: 'Transactions per page',
        },
        REPORTS: {
          EXPORT_ERROR: 'We couldn’t download the report.',
          COL_TRIPS: 'Trips',
          COL_HOURS: 'Hours online',
          COL_FARE: 'Revenue',
          COL_ACCEPTANCE: 'Acceptance',
          COL_RATING: 'Rating',
          EMPTY: 'No activity in this period.',
          LOAD_ERROR: 'We couldn’t load the performance.',
          SHOWING: 'Showing {{shown}} of {{total}} drivers',
          PER_PAGE: '{{count}} per page',
          PER_PAGE_ARIA: 'Drivers per page',
        },
        TEAM: {
          INVITE: 'Invite someone',
          INVITE_SUB: 'They’ll get an email to access the panel.',
          TITLE: 'People with access',
          SUB: 'Who can access the fleet panel and what they can do.',
          COL_MEMBER: 'Person',
          COL_ROLE: 'Role',
          STATUS_invited: 'Invited',
          STATUS_active: 'Active',
          EMPTY: 'There’s nobody on the team yet.',
          LOAD_ERROR: 'We couldn’t load the team.',
          EMAIL: 'Email',
          EMAIL_INVALID: 'Enter a valid email.',
          SEND_INVITE: 'Send invitation',
          INVITED_TITLE: 'Invitation sent to {{email}}',
          CHANGE_ROLE: 'Change role',
          LAST_OWNER: 'The fleet must have at least one owner.',
          REMOVE: 'Remove from team',
          REMOVING: 'Removing…',
          REMOVED: 'Removed',
          REMOVE_TITLE: 'Remove {{name}} from the team',
          REMOVE_TEXT: 'They’ll lose access to the fleet panel.',
          REMOVE_TEXT_INVITED: 'The invitation will stop working.',
          REMOVE_ERROR: 'We couldn’t remove them from the team',
        },
        SETTINGS: {
          LOAD_ERROR: 'We couldn’t load the settings.',
          COMPANY_TITLE: 'Fleet details',
          COMPANY_SUB: 'What it’s called and which email we write to.',
          NAME: 'Fleet name',
          CONTACT_EMAIL: 'Contact email',
          MODE: 'Service type',
          LOCKED_FIELDS: 'The service type and region can’t be changed. If you need to, contact support.',
          BILLING_SUB: 'Who we invoice.',
          BILLING_WARN: 'When you save, the details go back into review. Meanwhile we keep invoicing with the previous ones.',
          BILLING_IN_REVIEW: 'WAIIS is reviewing the latest changes. You’ll be able to edit them when it’s done.',
          SLOTS_TITLE: 'Shift slots',
          SLOTS_SUB: 'The same for the whole fleet; the night one can go past midnight. If you change the hours, they apply from next week.',
          SLOT_START: 'Starts',
          SLOT_END: 'Ends',
          SLOT_INVALID: 'Enter a start and end time, and they can’t be the same.',
          CROSSES_MIDNIGHT: 'Goes past midnight',
          NOTIFICATIONS_TITLE: 'Email alerts',
          NOTIFICATIONS_SUB: 'They’re sent to {{email}}.',
          NOTIFY_documentExpiring: 'A document expires soon',
          NOTIFY_documentRejected: 'WAIIS rejects a document',
          NOTIFY_driverRequests: 'A driver asks to join',
          NOTIFY_weeklySettlement: 'Weekly settlements summary',
        },
      },
    },
    PAGE_HEADER: {
      FLEET_DRIVERS: 'Accept drivers who link with your fleet code and check the status of their documents.',
      FLEET_VEHICLES: 'The fleet’s cars, their licence and their documents.',
      FLEET_DOCUMENTS: 'The status and expiry of company and vehicle documents.',
      FLEET_SETTLEMENTS: 'What the fleet has earned and the split of each trip.',
      FLEET_REPORTS: 'Trip, driver and settlement reports to download.',
      FLEET_TEAM: 'The people who manage the fleet with you and their role.',
      FLEET_SETTINGS: 'Fleet details, billing, shift slots and alerts.',
    },
  },
};
